module.exports = __webpack_public_path__ + "static/img/a002.5e6c5bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a002.jpg
// module id = /BEK
// module chunks = 0